import { Node } from 'tiptap'

export default class Title extends Node {
    get name() {
        return 'title2'
    }
    get schema() {
        return {
            content: 'inline*',
            parseDOM: [
                {
                    tag: 'h1',
                }
            ],
            toDOM: () => ['h1', 0],
        }
    }
}